import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'sm:w-[640px] lg:pt-40',
    title: 'heading-2xl lg:heading-3xl mb-3',
    description: 'heading-m mb-8 lg:mb-10',
    buttons: 'flex gap-[12px]'
  }
});
